import { render, staticRenderFns } from "./variable.vue?vue&type=template&id=2c09b537&scoped=true"
import script from "./variable.vue?vue&type=script&lang=js"
export * from "./variable.vue?vue&type=script&lang=js"
import style0 from "./variable.vue?vue&type=style&index=0&id=2c09b537&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c09b537",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c09b537')) {
      api.createRecord('2c09b537', component.options)
    } else {
      api.reload('2c09b537', component.options)
    }
    module.hot.accept("./variable.vue?vue&type=template&id=2c09b537&scoped=true", function () {
      api.rerender('2c09b537', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notify/systemScene/components/variable.vue"
export default component.exports